import { combineReducers } from "redux";
import createNamedWrapperReducer from "../../../feature/Markets/Common/Reducers/wrapperReducer";
import dashboardHoldingSummary from "./DashboardHoldingSummary";
import dashboardSummary from "./DashboardSummary";
export default combineReducers({
    holdings: createNamedWrapperReducer(dashboardHoldingSummary, "holdings"),
    pnlReport: createNamedWrapperReducer(dashboardSummary, "pnlReport"),
});
